/** Remove dash separators and surrounding spaces, uppercase. */
export const normalizeKey = (value: string | undefined | null): string =>
  (value || '').replace(/-/g, '').replace(/\s/g, '').toUpperCase();

/** Allow only latin letters, digits and dashes; cap the hex part at 16 chars. */
export const filterKeyInput = (value: string): string => {
  const allowed = (value || '').replace(/[^a-zA-Z0-9-]/g, '');
  const dashless = allowed.replace(/-/g, '');
  if (dashless.length <= 16) return allowed;
  // Trim extra hex chars while preserving dash grouping already typed.
  let hexCount = 0;
  let out = '';
  for (const ch of allowed) {
    if (ch === '-') {
      out += ch;
      continue;
    }
    if (hexCount < 16) {
      out += ch;
      hexCount += 1;
    }
  }
  return out;
};

/** True when the value is exactly 16 hex chars after removing dashes. */
export const isValidKey = (value: string | undefined | null): boolean =>
  /^[0-9A-Fa-f]{16}$/.test(normalizeKey(value));
